// 设置 rem 函数
function setRem () {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    if(flag){
        let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
        let htmlDom = document.getElementsByTagName('html')[0];
        htmlDom.style.fontSize= htmlWidth/7.5 + 'px';
    }else{
        let deviceWidth = document.documentElement.clientWidth;
        if(deviceWidth> 1920){
            deviceWidth = 1920
            document.getElementsByTagName('html')[0].style.cssText = 'font-size:' + deviceWidth / 19.2 + 'px !important'
        }else if(deviceWidth>1440){
            deviceWidth = document.documentElement.clientWidth
            document.getElementsByTagName('html')[0].style.cssText = 'font-size:' + deviceWidth / 19.2 + 'px !important'
        }else{
            deviceWidth = document.documentElement.clientWidth
            document.getElementsByTagName('html')[0].style.cssText = 'font-size:' + deviceWidth / 19.2 + 'px !important'
        }
    }
}
// 初始化
setRem();
// 改变窗口大小时重新设置 rem
window.onresize = function () {
    setRem()
}